export default __webpack_public_path__ + "static/media/hotel-8.bd07272a.jpg";